import { render } from "./PolicyInsurer.vue?vue&type=template&id=eb17fbb2"
import script from "./PolicyInsurer.vue?vue&type=script&lang=js"
export * from "./PolicyInsurer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__